import { render, staticRenderFns } from "./BatchSetSKUImg.vue?vue&type=template&id=460a281c"
import script from "./BatchSetSKUImg.vue?vue&type=script&lang=js"
export * from "./BatchSetSKUImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports